import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {
    Popover,Position,
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class TeamPlayer extends Component {
    
  render() {
    return (
        <li className="col">
            <Popover position={Position.RIGHT}>
            <img src={this.props.image}/>
          <div className="team_popover">
            {this.props.desc}
          </div>
        </Popover>
            <div className="team_player_name">{this.props.name}</div>
            <div className="team_role">{this.props.role}</div>
        </li>
    );
  }
}

export default TeamPlayer;